/**
 * Theme context - provides design-mode-aware theme to all pages.
 */
import React, { createContext, useContext } from 'react';
import { theme as baseTheme, getThemeForDesignMode } from '../config/theme';
import { useDesignMode } from './DesignModeContext';

type Theme = typeof baseTheme;

const ThemeContext = createContext<Theme | null>(null);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { designMode } = useDesignMode();
  const theme = getThemeForDesignMode(designMode);

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme(): Theme {
  const ctx = useContext(ThemeContext);
  return ctx ?? baseTheme;
}
